import React from 'react';
import './refundpolicy.css';

function RefundPolicy() {
  return (
    <div className="refund-policy-container">
      <h1>Refund Policy</h1>
      <p>
        Thank you for registering for the <strong>Diyatharippu 1st International Optometric Conference</strong>. 
        We understand that plans may change, and we aim to provide a fair and transparent refund policy.
      </p>

      <div className="refund-policy-section">
        <h2>Conference Registration Refunds</h2>
        <p>
          Requests for registration refunds must be made in writing to our event team. Refund eligibility is as follows:
        </p>
        <ul>
          <li>50% Refund – If cancellation is made <strong>90 days</strong> before the event.</li>
          <li>No Refund – If cancellation is made <strong>89 days or less</strong> before the event.</li>
        </ul>
      </div>

      <div className="refund-policy-section">
        <h2>Workshop & Special Sessions</h2>
        <p> 
          You may transfer your registration to another attendee by notifying us at least <strong>7 days</strong> before the event.
        </p>
      </div>

      <div className="refund-policy-section">
        <h2>Accommodation & Travel</h2>
        <p>
          The conference organizers are not responsible for any refunds related to travel, 
          accommodation, or personal expenses incurred by the attendee.
        </p>
      </div>

      <div className="refund-policy-section">
        <h2>Force Majeure Policy</h2>
        <p>
          In case of an event cancellation due to unforeseen circumstances such as 
          natural disasters, political instability, or pandemics, the organizers will communicate 
          alternative solutions, including rescheduling or partial refunds.
        </p>
      </div>

      <div className="refund-policy-section">
        <h2>Processing Time</h2>
        <p>
          Refund requests will be processed within <strong>10-15 business days</strong>. The actual 
          refund timeline may vary based on the payment provider.
        </p>
      </div>

      <div className="refund-policy-section refund-contact-section">
        <h2>Contact Us</h2>
        <p>
          If you have any questions regarding the refund policy, please contact our event support team at:  
        </p>
        <p>
          📧 <strong>Email:</strong> ecinstitute@gmail.com
        </p>
        <p>
        📞 <strong>Phone:</strong> +94 773 440 937
        </p>
      </div>
    </div>
  );
}

export default RefundPolicy;
